import React, { FC, useEffect, useState } from 'react';
import { LandscapeAboutParticipantAddTemplate } from '../../templates';
import { ParticipantResponseDto } from '../../../store/landscapeAPI/participant/dto/response/participant-response.dto';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchParticipantById,
  updateParticipant,
} from '../../../store/landscapeAPI/participant/reducers/participant.slice';
import { AppDispatch, RootState } from '../../../store/store';
import Spinner from '../../atoms/Spinner/Spinner';
import { ParticipantUpdateRequestDto } from '../../../store/landscapeAPI/participant/dto/request/participant-update-request.dto';

interface LandscapeAboutParticipantEditPageProps {}

const LandscapeAboutParticipantEditPage: FC<
  LandscapeAboutParticipantEditPageProps
> = () => {
  const { id } = useParams();
  const { participantId } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [participant, setParticipant] = useState<ParticipantResponseDto>();

  const { status } = useSelector((state: RootState) => state.participantSlice);

  useEffect(() => {
    if (participantId) {
      dispatch(fetchParticipantById(participantId))
        .unwrap()
        .then((response: ParticipantResponseDto) => setParticipant(response));
    }
  }, [participantId, dispatch]);

  const handleOnChange = (participant: ParticipantResponseDto) => {
    setParticipant(participant);
  };

  const callbackFn = async (participant: ParticipantResponseDto) => {
    const participantToUpdate: ParticipantUpdateRequestDto = {
      compactId: participant.compactId,
      name: participant.name,
      url: participant.url,
      organisationType: participant.organisationType,
      id: participant.id,
      published: true,
    };
    await dispatch(updateParticipant(participantToUpdate));
    if (id) {
      dispatch(fetchParticipantById(id));
    }
    navigate(`/landscapes/edit/${id}/about`);
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <>
      {participant && (
        <LandscapeAboutParticipantAddTemplate
          handleOnChange={handleOnChange}
          participant={participant}
          callbackFn={callbackFn}
        />
      )}
    </>
  );
};

export default LandscapeAboutParticipantEditPage;
